// Display rules of the customer's Lookups tab (ENG2-2849).

// The first row of lookup_trail. There is nothing to count before it.
export const TRAIL_STARTED_AT = '2026-10-16T12:20:00Z'

const TRAIL_FIRST_YEAR = new Date(TRAIL_STARTED_AT).getUTCFullYear()

const CHANNEL_LABELS: Record<string, string> = {
  api: 'API',
  dashboard: 'Dashboard',
  mcp: 'MCP',
}

export const channelLabel = (channel: string): string =>
  CHANNEL_LABELS[channel] ?? channel

const monthName = (month: number, options: Intl.DateTimeFormatOptions) =>
  new Date(Date.UTC(2000, month - 1, 1)).toLocaleDateString('en-GB', {
    timeZone: 'UTC',
    ...options,
  })

// '2026-10' -> 'October 2026'
export const monthLabel = (value: string): string => {
  const [year, month] = value.split('-').map(Number)
  return `${monthName(month, { month: 'long' })} ${year}`
}

export type MonthOption = { value: number; label: string }

// The months of a year that can hold lookups. Without the customer's first and
// last lookup (the answer was too large to count) that is all twelve.
export const monthOptions = (
  year: number,
  first: string | null,
  last: string | null,
): MonthOption[] => {
  const months = Array.from({ length: 12 }, (_, index) => index + 1)
  const inRange = (month: number) => {
    if (!first || !last) return true
    const firstDate = new Date(first)
    const lastDate = new Date(last)
    const key = year * 12 + month - 1
    return (
      key >= firstDate.getUTCFullYear() * 12 + firstDate.getUTCMonth() &&
      key <= lastDate.getUTCFullYear() * 12 + lastDate.getUTCMonth()
    )
  }
  return months.filter(inRange).map((value) => ({
    value,
    label: monthName(value, { month: 'long' }),
  }))
}

// Every year the trail can hold, newest first, for when the customer's own
// years are not known because the answer was too large to count.
export const yearsSinceTrailStart = (now: Date = new Date()): number[] => {
  const years = []
  for (let year = now.getUTCFullYear(); year >= TRAIL_FIRST_YEAR; year -= 1) {
    years.push(year)
  }
  return years
}

// The name CMAPI gives the 503 for a period too large to count within 45s.
export const isTooMuchData = (error: unknown): boolean =>
  (error as { response?: { data?: { error?: { name?: string } } } })?.response
    ?.data?.error?.name === 'lookupUsageTooMuchData'
